import { Outlet } from 'react-router';

import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { TCustomRouteObject } from '@/shared/types/router.types';

export const licensesRoutes: TCustomRouteObject = {
  path: '/license-management',
  hydrateFallbackElement: <FullscreenLoader />,
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'license-management',
      localized: true,
    },
    permission: { action: 'license:readLicense' },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { LicensesTableRoute } = await import('./licenses-table');
        return { Component: LicensesTableRoute };
      },
    },
  ],
};
